(function () {
  'use strict';
  // Sticky buy bar on mobile: shows when the main buy button scrolls out of view
  var sticky = document.querySelector('[data-sticky-buy]');
  var anchor = document.querySelector('[data-buy-anchor]');
  if (!sticky || !anchor || !('IntersectionObserver' in window)) return;
  document.body.classList.add('has-sticky');
  var anchorVisible = true, finalVisible = false;
  function update() {
    var show = !anchorVisible && !finalVisible && anchor.getBoundingClientRect().top < 0;
    sticky.classList.toggle('is-visible', show);
    sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
  }
  new IntersectionObserver(function (e) { anchorVisible = e[0].isIntersecting; update(); }).observe(anchor);
  document.querySelectorAll('[data-final-buy]').forEach(function (f) {
    new IntersectionObserver(function (e) { finalVisible = e[0].isIntersecting; update(); }).observe(f);
  });
})();
